import { financialInfoConstants } from "../_constants";
const financialInfoIntitalState = {
  userFinancialInfo: {
    primaryIncome: "",
    monthsAtEmployer: "",
    employerStreetAddress: "",
    employerStreetAddress2: "",
    employerPostalCode: "",
    employerState: "",
    employerCity: "",
    workNumber: "",
    incomePerPeriod: "",
    payFrequency: "",
    otherIncomeSource: "",
    monthlyOtherIncome: "",
  },
  financialInfoLoaded: false,
  employers: [],
  incomes: [],
  financialInfoFormOpen : false
};

export function financialInfo(state = financialInfoIntitalState, action) {
  switch (action.type) {
    case financialInfoConstants.LOAD_FINANCIAL_INFO_SUCCESS:
      const newFinancialInfo = action.financialInfo ? action.financialInfo : {};
      return {
        userFinancialInfo: newFinancialInfo,
        financialInfoLoaded: true,
        originalFinancialInfo: action.financialInfo,
      };

    case financialInfoConstants.SAVE_FINANCIAL_INFO_SUCCESS:
      return {
        userFinancialInfo: action.financialInfo,
        financialInfoLoaded: true,
        originalFinancialInfo: action.financialInfo,
      };
    case financialInfoConstants.EDIT_FINANCIAL_INFO_UPDATE:
      return { ...state, userFinancialInfo: action.financialInfo };
    case financialInfoConstants.ADD_EMPLOYER_SUCCESS: {
      const { employers } = state;
      employers.push(action.employer);
      return { ...state, employers: employers };
    }
    case financialInfoConstants.UPDATE_EMPLOYER_SUCCESS: {
      const { employers } = state;
      return {
        ...state,
        employers: employers.map((emp) => {
          if (emp.id == action.employer.id) {
            return {...emp,...action.employer};
          } else {
            return emp;
          }
        }),
      };
    }
    case financialInfoConstants.REMOVE_EMPLOYER_SUCCESS: {
      const { employers } = state;
      return {
        ...state,
        employers: employers.filter((s) => s.id !== action.id),
      };
    }
    case financialInfoConstants.ADD_INCOME_SUCCESS: {
      const { incomes } = state;
      incomes.push(action.income);
      return { ...state, incomes: incomes };
    }
    case financialInfoConstants.UPDATE_INCOME_SUCCESS: {
      const { incomes } = state;
      return {
        ...state,
        incomes: incomes.map((inc) => {
          if (inc.id == action.income.id) {
            return {...inc,...action.income};
          } else {
            return inc;
          }
        }),
      };
    }
    case financialInfoConstants.REMOVE_INCOME_SUCCESS: {
      const { incomes } = state;
      return {
        ...state,
        incomes: incomes.filter((s) => s.id !== action.id),
      };
    }
    case financialInfoConstants.LOAD_FINANCIALS_FROM_SESSION_SUCCESS:{
      const {employers,incomes} = action;
      return {
        ...state,
        employers,
        incomes
      }
    }
    case financialInfoConstants.FINANCIAL_INFO_FORM_OPEN:{
      return {
        ...state,
        financialInfoFormOpen : true,
      }
    }
    case financialInfoConstants.FINANCIAL_INFO_FORM_CLOSE:{
      return {
        ...state,
        financialInfoFormOpen : false,
      }
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/_reducers/financialInfo.reducer.js